import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { invoiceStatuses, roles, pageSize } from "../Mappings";
import {
  Typography,
  Grid,
  IconButton,
  Button,
  Tabs,
  Tab,
  Card,
  CardContent,
  Paper,
} from "@material-ui/core";
import { NavigateNext, NavigateBefore } from "@material-ui/icons";
import { UserDataContext } from "../Contexts/UserDataContext";
import { AppStateContext } from "../Contexts/AppStateContext";
import { LclDataContext } from "../Contexts/LclDataContext";
import { ParcelDataContext } from "../Contexts/ParcelDataContext";
import { HourlyDataContext } from "../Contexts/HourlyDataContext";
import { LinehaulFixedDataContext } from "../Contexts/LinehaulFixedDataContext";
import { LinehaulFloatingDataContext } from "../Contexts/LinehaulFloatingDataContext";
import LclDisplayDay from "./lcl/LclDisplayDay";
import ParcelDisplayDay from "./parcel/ParcelDisplayDay";
import LinehaulFixedDisplayDay from "./linehaulFixed/LinehaulFixedDisplayDay";
import LinehaulFloatingDisplayDay from "./linehaulFloating/LinehaulFloatingDisplayDay";
import HourlyDisplayDay from "./hourly/HourlyDisplayDay";
import ConfirmSubmitDialog from "./ConfirmSubmitDialog";
import { getFloatingRate, getWeekDates, formatDate, getDayOfWeekFromDate, getSingleDayString } from "../GlobalFunctions";
import { PropTypes } from "prop-types";
import { useRef } from "react";

const axios = require("axios");

const TruckViewPage = (props) => {
  const firstRender = useRef(true);
  const dataFetched = useRef([]);

  const { truckId, week } = props;
  const { userData } = useContext(UserDataContext);
  const { appState, setAppState } = useContext(AppStateContext);
  const { lclData, dispatch: dispatchLcl } = useContext(LclDataContext);

  const { parcelData, dispatch: dispatchParcel } = useContext(
    ParcelDataContext
  );
  const {
    linehaulFixedData,
    dispatch: dispatchLinehaulFixed,
    routesObj,
  } = useContext(LinehaulFixedDataContext);
  const { dispatch: dispatchLinehaulFloating } = useContext(
    LinehaulFloatingDataContext
  );
  const { hourlyData, dispatch: dispatchHourly } = useContext(
    HourlyDataContext
  );
  const [saveOpen, setSaveOpen] = useState(false);
  const { startDate, endDate } = getWeekDates(week);
  const history = useHistory();

  const [truckObj, setTruckObj] = useState(
    () =>
      userData.trucks.filter(
        (truckObj) => truckObj.truckId === Number(truckId)
      )[0]
  );

  const [floatingLinehaulRate, setFloatingLinehaulRate] = useState();
  const [lclSummaryPerEventDate, setlclSummaryPerEventDate] = useState([]);
  const [parcelSummaryPerEventDate, setParcelSummaryPerEventDate] = useState([]);
  const [hourlySummaryPerEventDate, setHourlySummaryPerEventDate] = useState([]);

  useEffect(() => {
    setFloatingLinehaulRate(getFloatingRate(week, truckObj.truckPayments));
  }, [truckObj, week]);  

  const requestLclData = async () => {
    console.log("loading dpc: lcl");

    let lclPage;
    let startDateParam = startDate.toISOString();
    let endDateParam = endDate.toISOString();
    let listingType = 'INSERT_NEW_ITEMS';

    if(!lclSummaryPerEventDate.length) {
      lclPage = 1
    }  else {
      const { currentPage, eventDate } = lclSummaryPerEventDate.find(x => x.isSelectedToLoadMore == true) ?? {};
      lclPage = currentPage ?? 1;

      if(eventDate) {
        const { startDayTime, endDayTime } = getSingleDayString(eventDate);
        startDateParam = startDayTime ?? startDate.toISOString();
        endDateParam =  endDayTime ?? endDate.toISOString();
      }
    }

    if(lclPage > 1) {
      listingType = 'UPDATE_LIST_ITEMS';
    }

    const request = {
      method: "GET",
      url: `/lcls/getdpc/${truckId}/${startDateParam}/${endDateParam}/${lclPage}/${pageSize}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };   

    try {
      const { data } = await axios(request);      
 
      if(!lclSummaryPerEventDate.length) {  
          const lclSummary = data.reduce((items, item) => {
          const { yyyy, MM, dd  } = formatDate(new Date(item.eventDateTime))
          const eventDate = `${yyyy}-${MM}-${dd}`
          const existingIndex = items?.findIndex((i) => i.eventDate === eventDate);
          //console.log(existingIndex);
          if (existingIndex < 0) {
            const { numberOfRecordsEventDate, totalStopPayPerEventDate, totalDpcPerEventDate, totalHomeDeliveryPerEventDate } = item;     

            items.push({
              eventDate,
              weekDay: getDayOfWeekFromDate(eventDate),
              totalRecords: numberOfRecordsEventDate,
              totalStopPay: totalStopPayPerEventDate,
              totalHomeDelivery: totalHomeDeliveryPerEventDate,
              totalDpc : totalDpcPerEventDate,
              currentPage: 1,
              currentListTotal: pageSize,
              isShowLoadMoreButton: (numberOfRecordsEventDate > pageSize) ? true : false,    
              isSelectedToLoadMore: false        
            });
          } 
          return items;
        }, []);

        lclSummary.length && setlclSummaryPerEventDate(lclSummary);        
      }
     
      
      dispatchLcl({
        type: listingType, 
        truckId,
        week,
        startDate,
        items: data 
      });   

    } catch (err) {
      console.log(err);
    }
  };  


  const requestParcelData = async () => {
    console.log("parcel");

    let parcelPage;
    let startDateParam = startDate.toISOString();
    let endDateParam = endDate.toISOString();
    let listingType = 'INSERT_NEW_ITEMS';

    if(!parcelSummaryPerEventDate.length) {
      parcelPage = 1
    }  else {
      const { currentPage, eventDate } = parcelSummaryPerEventDate.find(x => x.isSelectedToLoadMore == true) ?? {};
      parcelPage = currentPage ?? 1;

      if(eventDate) {
        const { startDayTime, endDayTime } = getSingleDayString(eventDate);
        startDateParam = startDayTime ?? startDate.toISOString();
        endDateParam =  endDayTime ?? endDate.toISOString();
      }
    }

    if(parcelPage > 1) {
      listingType = 'UPDATE_LIST_ITEMS';
    }

    const request = {
      method: "GET",
      url: `/parcels/getdpc/${truckId}/${startDateParam}/${endDateParam}/${parcelPage}/${pageSize}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      const { data } = await axios(request);


      if(!parcelSummaryPerEventDate.length) {  
        const parcelSummary = data.reduce((items, item) => {
        const { yyyy, MM, dd  } = formatDate(new Date(item.eventDate))
        const eventDate = `${yyyy}-${MM}-${dd}`
        const existingIndex = items?.findIndex((i) => i.eventDate === eventDate);
        //console.log(existingIndex);
        if (existingIndex < 0) {
          const { numberOfRecordsEventDate, totalDpcPerEventDate } = item;     

          items.push({
            eventDate,
            weekDay: getDayOfWeekFromDate(eventDate),
            totalRecords: numberOfRecordsEventDate,            
            totalDpc : totalDpcPerEventDate,
            currentPage: 1,
            currentListTotal: pageSize,
            isShowLoadMoreButton: (numberOfRecordsEventDate > pageSize) ? true : false,    
            isSelectedToLoadMore: false        
          });
        } 
          return items;
        }, []);

        parcelSummary.length && setParcelSummaryPerEventDate(parcelSummary);
      }

      dispatchParcel({
        type: listingType,
        truckId,
        week,
        startDate,
        items: data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const requestHourlyData = async () => {
    console.log("hourly");

    let hourlyPage;
    let startDateParam = startDate.toISOString();
    let endDateParam = endDate.toISOString();
    let listingType = 'INSERT_NEW_ITEMS';

    if(!hourlySummaryPerEventDate.length) {
      hourlyPage = 1
    }  else {
      const { currentPage, eventDate } = hourlySummaryPerEventDate.find(x => x.isSelectedToLoadMore == true) ?? {};
      hourlyPage = currentPage ?? 1;

      if(eventDate) {
        const { startDayTime, endDayTime } = getSingleDayString(eventDate);
        startDateParam = startDayTime ?? startDate.toISOString();
        endDateParam =  endDayTime ?? endDate.toISOString();
      }
    }

    if(hourlyPage > 1) {
      listingType = 'UPDATE_LIST_ITEMS';
    }

    const request = {
      method: "GET",
      url: `/rates/getdpc/${truckId}/${startDateParam}/${endDateParam}/${hourlyPage}/${pageSize}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      const { data } = await axios(request);

      if(!hourlySummaryPerEventDate.length) {  
        const hourlySummary = data.reduce((items, item) => {
        const { yyyy, MM, dd  } = formatDate(new Date(item.startTime))
        const eventDate = `${yyyy}-${MM}-${dd}`
        const existingIndex = items?.findIndex((i) => i.eventDate === eventDate);
        //console.log(existingIndex);
        if (existingIndex < 0) {
          const { numberOfRecordsEventDate } = item;     

          items.push({
            eventDate,
            weekDay: getDayOfWeekFromDate(eventDate),
            totalRecords: numberOfRecordsEventDate,           
            currentPage: 1,
            currentListTotal: pageSize,
            isShowLoadMoreButton: (numberOfRecordsEventDate > pageSize) ? true : false,    
            isSelectedToLoadMore: false        
          });
        }         
        return items;
        }, []);

        hourlySummary.length && setHourlySummaryPerEventDate(hourlySummary);
      }

      const items = data;

      dispatchHourly({
        type: listingType,
        truckId,
        week,
        startDate,
        items,
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

    const requestLinehaulFixedData = async () => {
      console.log("linehaulFixed");
      const request = {
        method: "GET",
        url: `/linehauls/getdpc/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      };
      try {
        const res = await axios(request);

        const items = res.data.map((item) => {
          const tripCost = Number(routesObj[item.routeId].routeRate);
          const totalCost = tripCost + Number(item.adjustment);
          return { ...item, tripCost, totalCost };
        });
        dispatchLinehaulFixed({
          type: "INSERT_NEW_ITEMS",
          truckId,
          week,
          startDate,
          items,
        });
      } catch (err) {
        console.log(err);
      }
    };

    const requestLinehaulFloatingData = async () => {
      console.log("linehaulFloating");
      console.log(week);
      const request = {
        method: "GET",
        url: `/floating/getdpc/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userData.token}`,
        },
      };
      try {
        const res = await axios(request);

        dispatchLinehaulFloating({
          type: "INSERT_NEW_ITEMS",
          truckId,
          week,
          startDate,
          items: res.data,
        });
      } catch (err) {
        console.log(err);
      }
    };

    if (!dataFetched.current.includes(appState.tab)) {
      //requestLclData();
      //requestParcelData();
      //requestHourlyData();
      requestLinehaulFixedData();
      requestLinehaulFloatingData();
      dataFetched.current.push(appState.tab);
    }
  }, []);

  useEffect(() => {
    if(!lclSummaryPerEventDate.length || 
        lclSummaryPerEventDate.some(item => item.currentPage > 1)
    ) {
      requestLclData();  
    } else {
      console.log('skip effect lcl')
    }
  }, [lclSummaryPerEventDate])

  useEffect(() => {
    if(!parcelSummaryPerEventDate.length || 
      parcelSummaryPerEventDate.some(item => item.currentPage > 1)
    ) {
      requestParcelData();
    } else {
      console.log('skip effect parcel')
    }    
  }, [parcelSummaryPerEventDate])

  useEffect(() => {
    if(!hourlySummaryPerEventDate.length || 
      hourlySummaryPerEventDate.some(item => item.currentPage > 1)
    ) {
      requestHourlyData();
    } else {
      console.log('skip effect hourly')
    }    
  }, [hourlySummaryPerEventDate])

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
    }
  }, [lclData, parcelData, linehaulFixedData, hourlyData]);

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="stretch"
      spacing={2}
    >
      <Grid item>
        <Typography variant="h3">Truck #{truckId}</Typography>
      </Grid>

      <Grid item>
        <Card>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={1}
          >
            <Grid item>
              <IconButton
                onClick={() => {
                  history.push(
                    `/${userData.userName}/trucks/${truckId}/weeks/${week + 1}`
                  );
                }}
                disabled={week === 4}
              >
                <NavigateBefore />
              </IconButton>
            </Grid>

            <Grid item>
              <Typography variant="h5">{`${startDate.toLocaleDateString(
                "en-GB"
              )} → ${endDate.toLocaleDateString("en-GB")}`}</Typography>
            </Grid>

            <Grid item>
              <Typography variant="subtitle1">
                {invoiceStatuses[userData.invoiceStatuses[truckId][week]]}
              </Typography>
            </Grid>

            <Grid item>
              <IconButton
                onClick={() => {
                  history.push(
                    `/${userData.userName}/trucks/${truckId}/weeks/${week - 1}`
                  );
                }}
                disabled={week === 0}
              >
                <NavigateNext />
              </IconButton>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      <Grid item>
        <Paper>
          <Tabs
            // value={tab}
            // onChange={(event, newTab) => setTab(newTab)}
            value={appState.tab}
            onChange={(event, newTab) =>
              setAppState({ ...appState, tab: newTab })
            }
            aria-label="disabled tabs example"
            textColor="primary"
          >
            <Tab label="LCL" />
            <Tab label="Parcel" />
            <Tab label="Hourly" />
            <Tab
              label="Linehaul Fixed"
              disabled={truckObj.routes.length === 0}
            />
            <Tab label="Linehaul Floating" disabled={!floatingLinehaulRate} />
          </Tabs>
        </Paper>
      </Grid>

      {
        // change content depending on tab value
        [
          <Grid item>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <LclDisplayDay
                key={day}
                truckId={truckId}
                week={week}
                day={day}
                lclSummary={lclSummaryPerEventDate.find(x => x.weekDay == day)}
                setlclSummaryPerEventDate={setlclSummaryPerEventDate}
              />
            ))}
          </Grid>,
          <Grid item>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <ParcelDisplayDay
                key={day}
                truckId={truckId}
                week={week}
                day={day}
                parcelSummary={parcelSummaryPerEventDate.find(x => x.weekDay == day)}
                setParcelSummaryPerEventDate={setParcelSummaryPerEventDate}
              />
            ))}
          </Grid>,
          <>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <Grid item key={day}>
                <HourlyDisplayDay truckId={truckId} week={week} day={day} 
                    hourlySummary={hourlySummaryPerEventDate.find(x => x.weekDay == day)}
                    setHourlySummaryPerEventDate={setHourlySummaryPerEventDate}   
                />
              </Grid>
            ))}
          </>,
          <Grid item>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <LinehaulFixedDisplayDay
                key={day}
                truckId={truckId}
                week={week}
                day={day}
              />
            ))}
          </Grid>,
          <Grid item>
            {[0, 1, 2, 3, 4, 5, 6].map((day) => (
              <LinehaulFloatingDisplayDay
                truckId={truckId}
                week={week}
                day={day}
                key={day}
              />
            ))}
          </Grid>,
        ][appState.tab]
      }

      {userData.roleId === roles.ownerDriver && (
        <Grid item>
          <Card>
            <CardContent>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setSaveOpen(true)}
                disabled={
                  !(
                    userData.invoiceStatuses[truckId][week] ===
                    invoiceStatuses.unsubmitted
                  )
                }
              >
                Submit Weekly Data
              </Button>
            </CardContent>
            <ConfirmSubmitDialog
              open={saveOpen}
              setOpen={setSaveOpen}
              truckId={truckId}
              week={week}
            />
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default TruckViewPage;

TruckViewPage.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
};
